(function() {
    'use strict';

    angular
        .module('gwApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider','$rootScopeProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('allocation2', {
                parent: 'module',
                url: '/allocation2',
                params:{page: null},
                data: {
                    authorities: ['ROLE_MATERIAL_ALLOCATION']
                },
                views: {
                    'content': {
                        templateUrl: 'app/accessories/allocation/allocation.html',
                        controller: 'AllocationTwoController',
                        controllerAs: 'vm'
                    }
                }
            })
    }
})();
